<template src="./create_box.pug" lang="pug"></template>

<script>
  import selectedProductComponent from './selected_product/selected_product.vue';

  export default {
    props: {
      shipment: Object,
      close: { type: Function, default: null },
      submit: { type: Function, default: null },
    },
    data() {
      return {
        shelf: '',
        weight: '',
        height: '',
        width: '',
        length: '',
        validators: {
          shelf: {
            valid: null,
            regexp: 100,
            validator: 'shelf',
          },
          weight: {
            valid: null,
            regexp: 50,
            validator: 'weight',
          },
          height: {
            valid: null,
            regexp: 100,
            validator: 'height',
          },
          width: {
            valid: null,
            regexp: 100,
            validator: 'width',
          },
          length: {
            valid: null,
            regexp: 100,
            validator: 'length',
          },
          products: {
            valid: true,
          },
        },
      };
    },
    computed: {
      selectedProducts() {
        return (this.shipment.products.filter((product) => product.selected) || [])
          .map((item) => {
            item.selected_quantity = item.quantity;
            return item;
          });
      },
      isButtonActive() {
        return Object.keys(this.validators)
          .filter((key) => this.validators[key].valid === true)
          .length === Object.keys(this.validators).length;
      },
    },
    components: {
      selectedProduct_component: selectedProductComponent,
    },
    methods: {
      create() {
        if (this.selectedProducts.length === 0) return this.close();
        const products = this.selectedProducts;

        const preparedData = [];

        products.forEach((item) => {
          const ids = item.ids.slice(0, item.selected_quantity);
          preparedData.push(...ids);
        });

        const data = {
          shelf: this.shelf,
          weight: this.weight,
          height: this.height,
          width: this.width,
          length: this.length,
          shipment_id: this.shipment.id,
          products: preparedData,
        };

        this.$store.dispatch('boxes/create', data)
          .then(() => {
            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Box was created.' });
            this.submit();
          })
          .catch(() => {
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Box wasn\'t created. Please try again.' });
          });
      },

      isValid() {
        Object.keys(this.validators).forEach((key) => {
          const validator = this.validators[key];
          validator.valid = this.validate(validator.validator);
        });

        return Object.keys(this.validators)
          .filter((key) => this.validators[key].valid === true)
          .length === Object.keys(this.validators);
      },

      validate(type, value) {
        if (type === 'shelf') {
          this.validators[type].valid = value.length < this.validators[type].regexp;
          return;
        }

        this.validators[type].valid = value <= this.validators[type].regexp && value > 0;
      },

      updateProductsValidation() {
        const isValid = this.selectedProducts
          .filter((item) => item.selected_quantity > item.quantity || item.selected_quantity <= 0);

        this.validators.products.valid = isValid.length === 0;
      },
    },
  };
</script>
